import { render, staticRenderFns } from "./ImportResults.vue?vue&type=template&id=ace480ea&scoped=true&"
import script from "./ImportResults.vue?vue&type=script&lang=ts&"
export * from "./ImportResults.vue?vue&type=script&lang=ts&"
import style0 from "./ImportResults.vue?vue&type=style&index=0&id=ace480ea&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace480ea",
  null
  
)

export default component.exports